@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ErrorStateComponentButton {
  @extend %font-family-primary;

  border: 1px solid $color-primary-red;
  border-radius: 6px;
  background: $color-alert-red-background;
  color: $color-primary-red;
  cursor: pointer;
  font-weight: $font-weight-semibold;
  min-width: 240px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 6px 8px 6px 16px;

  .textWrapper {
    padding-left: 8px;
  }

  &:hover {
    background: $color-error-button-hover;
  }
}
